export default __webpack_public_path__ + "static/media/iwmi-logo-tools.2c4d9c9c.svg";